import { render } from "./ModalTemplate.vue?vue&type=template&id=59cde5aa&scoped=true"
import script from "./ModalTemplate.vue?vue&type=script&lang=js"
export * from "./ModalTemplate.vue?vue&type=script&lang=js"

import "./ModalTemplate.vue?vue&type=style&index=0&id=59cde5aa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59cde5aa"]])

export default __exports__